import {RefObject} from 'react'
import {
  Button,
  Dialog,
  DialogAction,
  DialogContent,
  DialogRef,
} from 'src/app/components'
import {LoadingIcon} from '../../../../../components/Icons'

export type BankRewardValidateDialogProps = {
  dialogRef?: RefObject<DialogRef>;
  errors: string[];
  isLoadingParse: boolean;
  isLoadingValidate: boolean;
  handleClickProceed: () => void;
};

const BankRewardValidateDialog = (props: BankRewardValidateDialogProps) => {
  const {isLoadingParse, isLoadingValidate, handleClickProceed, errors} = props

  return (
    <Dialog
      closeOnBackdropClicked={true}
      title={'Document Checking'}
      ref={props.dialogRef}
      size="xs"
    >
      <DialogContent>
        {(isLoadingParse || isLoadingValidate) ? (
          <div className="flex justify-center">
            <LoadingIcon />
          </div>
        ) : (
          <>
            {errors.length === 0 ? (
              <>
                <div className="flex justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="64px"
                    viewBox="0 -960 960 960"
                    width="64px"
                    fill="green"
                  >
                    <path
                      d="m381-240 424-424-57-56-368 367-169-170-57 57 227 226Zm0 113L42-466l169-170 170 170 366-367 172 168-538 538Z" />
                  </svg>
                </div>
                <p className="text-center text-sm">
                  Successfully parsed the file. Please proceed to validate the data.
                </p>
              </>
            ) : (
              <>
                <div className="flex justify-center">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M24 12C24 18.6264 18.6264 24 12 24C5.3736 24 0 18.6264 0 12C0 5.3736 5.3736 0 12 0C18.6264 0 24 5.3736 24 12Z"
                      fill="#F94D72" />
                    <path
                      d="M17.634 6.366C18.122 6.854 18.122 7.6455 17.634 8.1335L8.1335 17.634C7.6455 18.122 6.854 18.122 6.366 17.634C5.878 17.146 5.878 16.3545 6.366 15.8665L15.8665 6.366C16.3545 5.878 17.146 5.878 17.634 6.366Z"
                      fill="white" />
                    <path
                      d="M17.634 17.634C17.146 18.122 16.3545 18.122 15.8665 17.634L6.366 8.1335C5.878 7.6455 5.878 6.854 6.366 6.366C6.854 5.878 7.6455 5.878 8.1335 6.366L17.634 15.8665C18.122 16.3545 18.122 17.146 17.634 17.634Z"
                      fill="white" />
                  </svg>
                </div>
                <p className="text-center text-sm text-danger">
                  An error occurred. Please check the details below.
                </p>
              </>
            )}
          </>
        )}
        <div className="text-red">
          {props.errors.length > 0 && (
            <p className="text-danger text-xs">Please Revise your file</p>
          )}
          {props.errors.map((error, index) => (
            <li key={index} className="text-danger text-xs ml-2">
              {error}
            </li>
          ))}
        </div>
      </DialogContent>
      <DialogAction>
        <Button
          disabled={props.errors.length > 0 || isLoadingValidate}
          onClick={handleClickProceed}
        >
          Proceed
        </Button>
      </DialogAction>
    </Dialog>
  )
}

export default BankRewardValidateDialog